import { AngularMaterialModule } from '@uw/shared/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { BackButtonDirective } from './directives/back-button.directive';
import { NoRecordContainerComponent } from './components/no-record-container/no-record-container.component';
import {
  ActionNotificationComponent,
  ConfirmEntityDialogComponent,
  UpdateStatusDialogComponent,
  FetchEntityDialogComponent,
  AlertComponent,
  DeleteEntityDialogComponent,
} from './content/crud';
import { LayoutUtilsService } from './services/layout-utils.service';
import { AlertMessageBoxComponent } from './components/alert-message-box/alert-message-box.component';
import { SearchPipe } from './pipes/search.pipe';
import { FilterListPipe } from './pipes/filter-list.pipe';
import { DisabledControlDirective } from './directives/disabled-control.directive';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { ActionsModalComponent } from './components/actions-modal/actions-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ActionItemComponent } from './components/actions-modal/action-item/action-item.component';
import { TruncatePipe } from './pipes/truncate.pipe';
import {
  AcceptableCharactersDirective,
  BaseInputBlurDirective,
  MaxValueValidatorDirective,
  MinValueValidatorDirective,
  RangeValidatorDirective,
  RegexValidatorDirective,
} from './validators';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatPaginationIntlService } from './services/mat-pagination-intl-service';
import { NoRightClickDirective } from './directives/no-right-click-directive';
import { LocalizedDecimalPipe } from './pipes/localized-decimal.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { FieldErrorDisplayComponent } from './components/field-error-display/field-error-display.component';
import { PermissionDirective } from './directives/permission.directive';
import { ProgressWidgetComponent } from './components/progress-widget/progress-widget.component';
import { RoleNamePipe } from './pipes/role-name.pipe';
import { UwButtonModule } from './components/button/button.module';
import { FieldErrorDisplayModule } from './components/field-error-display/field-error-display.module';
import { PasswordComponent } from './components/password/password.component';

const contentModelComponents = [
  ActionNotificationComponent,
  UpdateStatusDialogComponent,
  FetchEntityDialogComponent,
  AlertComponent,
  DeleteEntityDialogComponent,
  ConfirmEntityDialogComponent,
];
@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        OverlayModule,
        AngularMaterialModule,
        UwButtonModule,
        ReactiveFormsModule,
        FieldErrorDisplayModule,
        ...contentModelComponents,
        PermissionDirective,
        BackButtonDirective,
        NoRecordContainerComponent,
        AlertMessageBoxComponent,
        NoRightClickDirective,
        SearchPipe,
        LocalizedDatePipe,
        FilterListPipe,
        LocalizedDecimalPipe,
        TruncatePipe,
        RoleNamePipe,
        SafeHtmlPipe,
        DisabledControlDirective,
        ActionsModalComponent,
        ActionItemComponent,
        MaxValueValidatorDirective,
        MinValueValidatorDirective,
        RangeValidatorDirective,
        AcceptableCharactersDirective,
        RegexValidatorDirective,
        BaseInputBlurDirective,
        ProgressWidgetComponent,
        PasswordComponent
    ],
    exports: [
        UwButtonModule,
        FieldErrorDisplayModule,
        BackButtonDirective,
        NoRecordContainerComponent,
        ...contentModelComponents,
        AlertMessageBoxComponent,
        ProgressWidgetComponent,
        PermissionDirective,
        NoRightClickDirective,
        SearchPipe,
        LocalizedDatePipe,
        FilterListPipe,
        LocalizedDecimalPipe,
        TruncatePipe,
        RoleNamePipe,
        SafeHtmlPipe,
        DisabledControlDirective,
        ActionsModalComponent,
        MaxValueValidatorDirective,
        MinValueValidatorDirective,
        RangeValidatorDirective,
        RegexValidatorDirective,
        AcceptableCharactersDirective,
        FieldErrorDisplayComponent,
        PasswordComponent
    ],
    providers: [
        LayoutUtilsService,
        {
            provide: MatPaginatorIntl,
            useClass: MatPaginationIntlService,
        },
    ]
})
export class SharedModule {}
// Components
